import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import AbstractDropdownOption from "components/library/AbstractDropdown/AbstractDropdownOption.js";
import styles from "./CreateTagAsyncDropdownOption.css";

export class TagTypeOptionName extends React.Component {
  render() {
    return (
      <span className={styles.root}>
        {this.props.option.name}
        <span className={classNames(styles.example, this.props.className)}>
          {this.props.option.example}
        </span>
      </span>
    );
  }
}

export default class CreateTagAsyncDropdownOption extends React.Component {
  render() {
    return (
      <AbstractDropdownOption
        {...this.props}
        nameComponent={TagTypeOptionName}
      />
    );
  }
}

TagTypeOptionName.propTypes = {
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
    example: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
};
